import React from "react";

import { JobContainer, Col, TitleSection, Row, Link } from "./index.style";
import { Container, Title } from "../index.style";
import PlaceHolder from "../../../images/post.png";

const Jobs = () => {
  return (
    <JobContainer>
      <Container>
        <TitleSection>
          <Title>How QuirkyCoders Helps you hire</Title>
          <p>
            QuirkyCoders helps you connect with talent, on desktop and mobile,
            so you can make more quality hires faster.
          </p>
        </TitleSection>
        <Row>
          <Col className="col">
            <img src={PlaceHolder} alt="QuirkyCoders helps you hire" />
          </Col>
          <Col className="col job">
            <Title>Post Jobs</Title>

            <h3>Get started for free</h3>
            <p>
              Anyone can post jobs for free.* Hiring online is simple when you
              post jobs directly on QuirkyCoders or through your company career
              site or ATS.
            </p>

            <h3>Invest to find the right fit faster</h3>
            <p>
              To attract more candidates, pay to sponsor your job. Sponsored
              jobs appear for longer than non-sponsored jobs, and they are 3.5X
              more likely to result in a hire.
            </p>

            <Link href="/subscriptions">Learn more about sponsored Jobs. </Link>
            <div className="source">
              <span>
                * Terms, conditions, quality standards and usage limits apply.
              </span>
              <span>Source: QuirkyCoders data(worldwide)</span>
            </div>
          </Col>
        </Row>
      </Container>
    </JobContainer>
  );
};

export default Jobs;
